export type SortDirection = 'asc' | 'desc';

export function compareValues(
  a: unknown,
  b: unknown,
  direction: SortDirection
): number {
  const aVal = (a ?? '') as any;
  const bVal = (b ?? '') as any;

  if (
    typeof aVal === 'string' &&
    typeof bVal === 'string'
  ) {
    const result = aVal.localeCompare(bVal);
    return direction === 'asc' ? result : -result;
  }

  if (aVal === bVal) return 0;

  const compare = aVal > bVal ? 1 : aVal < bVal ? -1 : 0;
  return direction === 'asc' ? compare : -compare;
}

export function toggleSortDirection<K>(
  currentColumn: K,
  column: K,
  currentDirection: SortDirection
): { column: K; direction: SortDirection } {
  if (currentColumn === column) {
    return {
      column,
      direction:
        currentDirection === 'asc' ? 'desc' : 'asc',
    };
  }

  return { column, direction: 'asc' };
}
